/**
 * Determines if the user can schedule an action or add delay
 *
 * @return {Boolean} True if the user can schedule an action or add delay
 */
const canManageSchedule = () => {
	return UncannyAutomatorBackend._site.automator.is_pro_active;
};

export default canManageSchedule;
